import { DEFAULT_LANGUAGE, TYPE_KEY } from "../common/constant";
import rest from "../common/rest";
import { getOptionListFromResult } from "../utils/OptionsUtils";
import { CHANGE_LANGUAGE_ACTION, LANGUAGE } from "./languageSelector";
import { createBackendErrorMessages, createErrorMessages, messagesReceived } from "./message";

export const REDUCER = "REGION/";
export const REGION_LIST_LOAD_SUCCESS = REDUCER + "REGION_LIST_LOAD_SUCCESS";

// state props
export const REGION_LIST = "regionList";
export const REGION_OPTIONS = "regionOptions";

const initialState = {
  [REGION_LIST]: [],
  [REGION_OPTIONS]: [],
  [LANGUAGE]: DEFAULT_LANGUAGE,
};

export default function reducer(state = initialState, action) {
  let newState;
  switch (action[TYPE_KEY]) {
    case REGION_LIST_LOAD_SUCCESS:
      newState = {
        ...state,
        [REGION_LIST]: action[REGION_LIST],
        [REGION_OPTIONS]: getOptionListFromResult(state[LANGUAGE], action[REGION_LIST])
      };
      break;

    case CHANGE_LANGUAGE_ACTION:
      newState = {
        ...state,
        [LANGUAGE]: action[LANGUAGE],
        [REGION_OPTIONS]: getOptionListFromResult(action[LANGUAGE], state[REGION_LIST])
      };
      break;

    default:
      newState = { ...state };
      break;
  }

  return newState;
}

export function loadRegions() {
  return (dispatch) => {
    rest.doGet(`/admin/admin/predefined/lectorate_region`).then(
      (result) => {
        if (result) {
          dispatch({ [TYPE_KEY]: REGION_LIST_LOAD_SUCCESS, [REGION_LIST]: result });
        } else {
          dispatch(messagesReceived(createErrorMessages(result)));
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
      }
    );
  };
}